import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  useEffect(() => {
    if (location.pathname !== "/") {
      return;
    }

    const timer = setTimeout(() => {
      const cookieConsent = getCookie("cookieConsent");

      if (!cookieConsent) {
        setShowBanner(true);
        setIsVisible(true);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const acceptCookies = () => {
    setCookie("cookieConsent", "accepted", 365);
    setShowBanner(false);
    setIsVisible(false);
  };

  const declineCookies = () => {
    setCookie("cookieConsent", "declined", 365);
    setShowBanner(false);
    setIsVisible(false);
  };

  const handleAcceptAll = () => {
    acceptCookies();
  };

  const handleAcceptNecessary = () => {
    setCookie("cookieConsent", "necessary", 365);
    setShowBanner(false);
    setIsVisible(false);
  };

  if (!showBanner || location.pathname !== "/") return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-30 transform transition-transform duration-300 ${isVisible ? "translate-y-0" : "translate-y-full"
        }`}
    >
      <div className="bg-white border-t border-gray-200 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
            {/* Content */}
            <div className="flex-1 mb-4 lg:mb-0 lg:mr-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {t("cookie_consent.title")}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {t("cookie_consent.text")}
              </p>
              <div className="mt-3 text-xs text-gray-500">
                <a
                  href="/privacy-policy"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  {t("cookie_consent.privacy_policy")}
                </a>
                {" • "}
                <Link
                  to="/cookie-policy"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  {t("cookie_consent.cookie_policy")}
                </Link>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 lg:shrink-0">
              <button
                onClick={handleAcceptAll}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
              >
                {t("cookie_consent.accept_all")}
              </button>
              <button
                onClick={handleAcceptNecessary}
                className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
              >
                {t("cookie_consent.necessary_only")}
              </button>
              <button
                onClick={declineCookies}
                className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
              >
                {t("cookie_consent.decline")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;